import React, { useCallback } from 'react';
import { IconButton } from 'components/buttons/IconButton';

interface IChartSeriaActionPanelProps {
  removeSeria: (seriaNumber: number) => void;
  moveSeriaUp: (seriaNumber: number) => void;
  moveSeriaDown: (seriaNumber: number) => void;
  seriaNumber: number;
  seriesLength: number;
}

export function ChartSeriaActionPanel({
  removeSeria,
  moveSeriaUp,
  moveSeriaDown,
  seriaNumber,
  seriesLength,
}: IChartSeriaActionPanelProps) {
  const moveUp = useCallback(() => moveSeriaUp(seriaNumber), [moveSeriaUp, seriaNumber]);
  const moveDown = useCallback(() => moveSeriaDown(seriaNumber), [moveSeriaDown, seriaNumber]);
  const remove = useCallback(() => removeSeria(seriaNumber), [removeSeria, seriaNumber]);

  return (
    <div className="dpc-chart-series-editor__action-panel">
      {seriesLength > 1 && seriaNumber < seriesLength - 1 && (
        <IconButton title="Move Down" iconClassName="dpc-chart-series-editor__arrow-down" onClick={moveDown} />
      )}
      {seriaNumber > 0 && <IconButton title="Move Up" iconClassName="dpc-chart-series-editor__arrow-up" onClick={moveUp} />}
      {seriesLength > 1 && (
        <IconButton title="Remove Series" iconClassName="dpc-chart-series-editor__clear-icon" onClick={remove} />
      )}
    </div>
  );
}
